import domain from '@/util/domain'
const urlImages = `https://dozr8la71aog.cloudfront.net/domains/${domain()}/img/exceptional`

const popular = [
  {
    label: "Série A",
    src: `${urlImages}/brasileiraoseriaa.png`,
    href: "/tournament/6046/35/20913?sport=Futebol&category=%20Brasil&tournament=%20Série%20A#scrollTop",
  },
  {
    label: "Série B",
    src: `${urlImages}/brasileiraoseriab.png`,
    href: "/tournament/6046/35/20917?sport=Futebol&category=%20Brasil&tournament=%20Série%20B#scrollTop",
  },
  {
    label: "Libertadores",
    src: `${urlImages}/libertadores.png`,
    href: "/countries/6046/?sport=Futebol&category=Libertadores#scrollTop",
  },
  {
    label: "Copa do Brasil",
    src: `${urlImages}/copadobrasil.png`,
    href: "tournament/6046/35/27388?sport=Futebol&category=Brasil&tournament=Copa%20do%20Brasil#scrollTop",
  },
  {
    label: "Internacional",
    src: `${urlImages}/internacional.png`,
    href: "/category/6046/125?sport=Futebol&category=%20Internacional#scrollTop",
  },
  {
    label: "Brasil",
    src: `${urlImages}/brasil.png`,
    href: "/category/6046/35?sport=Futebol&category=%20Brasil#scrollTop",
  },

  {
    label: "UEFA",
    src: `${urlImages}/championsleague.png`,
    href: "/countries/6046/?sport=Futebol&category=UEFA#scrollTop",
  },
  {
    label: "NBA",
    src: `${urlImages}/nba.png`,
    href: "/countries/48242/?sport=Basquete&category=Estados%20Unidos#scrollTop",

  },
  {
    label: "UFC/BOXE",
    src: `${urlImages}/fight.png`,
    href: "/countries/154919/?sport=UFC/Boxe&category=UFC%2FBoxe#scrollTop",
  },
]

export default popular

